import styled from '@emotion/styled'
import { Container } from '@mui/material'
import * as api from "api"
import { memo } from "react"
import Shared from "theme/shared"
import VehicleGalleryDesktop from "./VehicleGalleryDesktop"
import VehicleGalleryMobile from "./VehicleGalleryMobile"

type VehicleGalleriesProps = {
  data: {
    inOptions: api.VehicleOutInOptionsGallery[]
    outOptions: api.VehicleOutInOptionsGallery[]
  }
}

const Styled = {
  Wrapper: styled.div`
    margin-top: 30px;
    ${(p) => p.theme.breakpoints.up("md")} {
      margin-top: 70px;
    }
  `,
  Header: styled(Shared.Header)`
    margin-bottom: 40px;
  `,
}

const VehicleGalleries = ({ data }: VehicleGalleriesProps) => {
  return (
    <Container disableGutters>
      <Styled.Wrapper>
        <Shared.Desktop>
          <Styled.Header>מאפייני רכב</Styled.Header>
          <VehicleGalleryDesktop
            type="חוץ"
            reverse={false}
            data={data.outOptions}
          />
          <VehicleGalleryDesktop
            type="פנים"
            reverse={true}
            data={data.inOptions}
          />
        </Shared.Desktop>
        <Shared.Mobile>
          <VehicleGalleryMobile type="חוץ" data={data.outOptions} />
          <VehicleGalleryMobile type="פנים" data={data.inOptions} />
        </Shared.Mobile>
      </Styled.Wrapper>
    </Container>
  )
}

export default memo(VehicleGalleries)
